import { useState } from "react";
import ModalVideo from "react-modal-video";
import { Link } from "react-router-dom";
import Slider from "react-slick";

import sliderImg1 from "../../assets/images/slider/banner5.png";
import sliderImg2 from "../../assets/images/slider/2.jpg";
import sliderImg11 from "../../assets/images/slider/11.jpg";
import sliderImg12 from "../../assets/images/slider/12.jpg";
import { IAS_PEDAGOGY } from "../../app-constants";

const HomeSlider = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(!isOpen);

  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    margin: 0,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
        },
      },
    ],
  };

  return (
    <>
      <div className="react-slider-part">
        <ModalVideo
          channel="youtube"
          isOpen={isOpen}
          videoId={IAS_PEDAGOGY.YOUTUBE_INTRO}
          onClose={() => {
            openModal();
          }}
        />
        <div className="home-sliders home2">
          <Slider {...sliderSettings}>
            {" "}
            <div className="single-slide">
              <div className="slider-img">
                <img className="desktop" src={sliderImg1} />
                <img
                  className="mobile"
                  src={sliderImg11}
                  alt="Slider Image 1"
                />
              </div>
              <div className="container">
                <div className="slider-content">
                  <div className="content-part">
                    <span
                      className="slider-pretitle wow animate__fadeInUp"
                      data-wow-duration="1s"
                    >
                      An exam-focused UPSC plan
                    </span>
                    <h2
                      className="slider-title wow animate__fadeInUp"
                      data-wow-duration="1s"
                    >
                      {" "}
                      Structured learning, intensive practice, and refined
                      answer writing
                    </h2>
                    <div
                      className="slider-btn wow animate__fadeInUp"
                      data-wow-duration="1.2s"
                    >
                      <Link
                        to={`https://wa.me/${
                          IAS_PEDAGOGY.WHATSAPP_CHAT
                        }?text=${encodeURIComponent(
                          IAS_PEDAGOGY.WHATSAPP_CHAT_MESSAGE
                        )}`}
                        target="_blank"
                        className="react-btn-border"
                      >
                        Admissions
                      </Link>
                    </div>
                  </div>
                </div>
                <div
                  className="event__video-btn--play wow animate__fadeInUp"
                  data-wow-duration="1.4s"
                >
                  <Link
                    to="#"
                    className="event__video-btn--play-btn custom-popup"
                    onClick={() => {
                      openModal();
                    }}
                  >
                    <i className="arrow_triangle-right"></i>
                    <em>
                      Watch <br />
                      Intro
                    </em>
                  </Link>
                </div>
              </div>
            </div>
            <div className="single-slide">
              <div className="slider-img">
                <img
                  className="desktop"
                  src={sliderImg2}
                  alt="Slider Image 1"
                />
                <img
                  className="mobile"
                  src={sliderImg12}
                  alt="Slider Image 1"
                />
              </div>
              <div className="container">
                <div className="slider-content">
                  <div className="content-part">
                    <span
                      className="slider-pretitle wow animate__fadeInUp"
                      data-wow-duration="3s"
                    >
                      The Future of UPSC Preparation
                    </span>
                    <h2
                      className="slider-title wow animate__fadeInUp"
                      data-wow-duration="1s"
                    >
                      A unique, battle-tested strategy <br />
                      that has never been revealed before
                    </h2>
                    <div
                      className="slider-btn wow animate__fadeInUp"
                      data-wow-duration="1.2s"
                    >
                      <Link
                        to={`https://wa.me/${
                          IAS_PEDAGOGY.WHATSAPP_CHAT
                        }?text=${encodeURIComponent(
                          IAS_PEDAGOGY.WHATSAPP_CHAT_MESSAGE
                        )}`}
                        target="_blank"
                        className="react-btn-border"
                      >
                        Admissions
                      </Link>
                    </div>
                  </div>
                </div>
                <div
                  className="event__video-btn--play wow animate__fadeInUp"
                  data-wow-duration="1.4s"
                >
                  <Link
                    to="#"
                    className="event__video-btn--play-btn custom-popup"
                    onClick={() => {
                      openModal();
                    }}
                  >
                    <i className="arrow_triangle-right"></i>
                    <em>
                      Watch <br />
                      Intro
                    </em>
                  </Link>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </>
  );
};

export default HomeSlider;
